// ============================================================================
// kh-prezzi-shopify.js — TUTTI i prezzi €/m2 vengono da Shopify (variant.unit_price).
// Niente Worker, niente prezzi fissi, niente CDN. Sostituisce Shopify (unit_price) + Shopify (unit_price)
// ============================================================================
if (!window.__KH_PREZZI_LOADED__) {
window.__KH_PREZZI_LOADED__ = true;
window.khMinMqFromVariants = function(variants){
  /* FONTE UNICA del criterio €/mq: ritorna la variante col unit_price (€/mq) piu' BASSO, esclusi battiscopa (o null). Usata da enricher, ultra-search, carosello correlati. */
  var best = null;
  (variants || []).forEach(function(v){
    if (v.unit_price == null || parseFloat(v.unit_price) <= 0) return;
    if (/batt/i.test(v.option1 || '') || /battiscopa/i.test(v.title || '')) return;
    if (best === null || parseFloat(v.unit_price) < parseFloat(best.unit_price)) best = v;
  });
  return best;
};
window.khScatolaPerMq = function(mqCents, fallback){ /* KH 2026-08-07: il 2° arg = prezzo scatola autorevole del formato/variante corrente -> usalo, evita collisioni €/mq (es. 60x120 e 90x90 stesso €/mq -> box diverso) */ if(fallback!=null) return fallback; try { if(mqCents==null) return fallback; var vs=(window.productData&&window.productData.variants)||[]; for(var i=0;i<vs.length;i++){ if(vs[i].unit_price==mqCents && vs[i].price!=null) return vs[i].price; } } catch(e){} return fallback; };

window.SUPERGRES_PRODUCTS = window.SUPERGRES_PRODUCTS || {};
// stub: queste cercavano nel Worker per TITOLO; ora non servono (le card usano fetch unit_price)
window.getPrezzoMinimoM2 = function(){ return null; };
window.getMinPrezzoM2Prodotto = function(){ return null; };
window.cercaPrezzoMinimo = function(){ return null; };
window.cercaPrezzoMinimoProdotto = function(){ return null; };
window.cercaChiaveIntelligente = function(){ return null; };

// ============================================================================
// KH-SHOPIFY-PRICES — Sul configuratore (pagina prodotto) i prezzi vengono presi
// SOLO da Shopify: variant.unit_price (€/m2), variant.kh_compare/compare_at_price
// (barrato), variant.price (scatola). Niente Worker, niente prezzi fissi.
// getPrezzoFissoM2 e getPrezzoByComparePrice ritornano SEMPRE un unit_price valido
// (mai null) cosi nessuno step puo ripiegare sul prezzo scatola.
// Fuori dalla pagina prodotto (ricerca/collezioni) restano le funzioni originali.
// ============================================================================
(function() {
  var _origFisso = window.getPrezzoFissoM2;
  var _origCompare = window.getPrezzoByComparePrice;
  function _vs(){ var vs = (window.productData && window.productData.variants) || []; var U = window.__KH_UNIT__; if (U) { for (var i=0;i<vs.length;i++){ var u = U[vs[i].id]; if (u && vs[i].unit_price == null) { vs[i].unit_price = u.p; vs[i].kh_compare = u.c; } } } return vs; }
  function _dim(s){ var m = (s||'').toLowerCase().match(/(\d+(?:[.,]\d+)?)\s*[x×]\s*(\d+(?:[.,]\d+)?)/); return m ? (m[1]+'x'+m[2]).replace(/,/g,'.') : null; }
  function _ret(v){
    if (!v) return null;
    var comp = (v.kh_compare != null) ? v.kh_compare : (v.compare_at_price != null ? v.compare_at_price : null);
    return { prezzo: v.unit_price/100, comparePrice: (comp == null ? null : comp/100), scatola: v.price };
  }
  function _lower(x){ return (''+x).toLowerCase(); }

  window.getPrezzoFissoM2 = function(formato, productTitle, colore, spessore, sku) {
    var vs = _vs();
    if (!vs.length) return _origFisso ? _origFisso.apply(this, arguments) : null; // fuori dal configuratore
    var fdim = _dim(formato);
    var _finTok = ((formato==null?'':(''+formato)).normalize('NFD').replace(/[̀-ͯ]/g,'').toLowerCase().split('-')).slice(1).filter(function(t){return t && t!=='battiscopa';});
    var _finOk = function(v){ if(!_finTok.length) return true; var hay=(((v.option1||'')+' '+(v.option3||'')).normalize('NFD').replace(/[̀-ͯ]/g,'')).toLowerCase().replace(/\s+/g,''); return _finTok.every(function(t){ return hay.indexOf(t.replace(/\s+/g,''))!==-1; }); };
    var bySku=null, byDimCol=null, byDim=null, any=null;
    var hasSku = sku && sku !== 'undefined' && sku !== 'null';
    var hasCol = colore && colore !== 'null' && colore !== 'undefined';
    for (var i=0;i<vs.length;i++){ var v = vs[i];
      if (v.unit_price == null) continue;
      if (!_finOk(v)) continue; /* FIX 25-06: filtra per finitura (RealUp/Grip/Lappata stesso formato) */
      if (any === null || v.unit_price < any.unit_price) any = v;
      var dm = fdim && _dim(v.option1) === fdim;
      if (dm && (byDim === null || v.unit_price < byDim.unit_price)) byDim = v;
      if (hasSku && v.sku === sku) { bySku = v; }
      if (dm && hasCol && v.option2 && _lower(v.option2) === _lower(colore)) {
        if (byDimCol === null || v.unit_price < byDimCol.unit_price) byDimCol = v;
      }
    }
    return _ret(bySku || byDimCol || byDim || any);
  };

  window.getPrezzoByComparePrice = function(compareShopify, productTitle, finitura, formato, colore) {
    var vs = _vs();
    if (!vs.length) return _origCompare ? _origCompare.apply(this, arguments) : null; // fuori dal configuratore
    var c = parseInt(compareShopify, 10);
    var fdim = _dim(formato);
    var _finTok = ((formato==null?'':(''+formato)).normalize('NFD').replace(/[̀-ͯ]/g,'').toLowerCase().split('-')).slice(1).filter(function(t){return t && t!=='battiscopa';});
    var _finOk = function(v){ if(!_finTok.length) return true; var hay=(((v.option1||'')+' '+(v.option3||'')).normalize('NFD').replace(/[̀-ͯ]/g,'')).toLowerCase().replace(/\s+/g,''); return _finTok.every(function(t){ return hay.indexOf(t.replace(/\s+/g,''))!==-1; }); };
    var byAll=null, byComp=null, byDim=null, any=null;
    var hasCol = colore && colore !== 'null' && colore !== 'undefined';
    for (var i=0;i<vs.length;i++){ var v = vs[i];
      if (v.unit_price == null) continue;
      if (!_finOk(v)) continue; /* FIX 25-06: filtra per finitura (RealUp/Grip/Lappata stesso formato) */
      if (any === null || v.unit_price < any.unit_price) any = v;
      var dm = fdim && _dim(v.option1) === fdim;
      if (dm && (byDim === null || v.unit_price < byDim.unit_price)) byDim = v;
      var compMatch = !isNaN(c) && (parseInt(v.compare_at_price,10) === c || parseInt(v.kh_compare,10) === c);
      if (compMatch) {
        if (byComp === null || v.unit_price < byComp.unit_price) byComp = v;
        if (hasCol && v.option2 && _lower(v.option2) === _lower(colore)) {
          if (byAll === null || v.unit_price < byAll.unit_price) byAll = v;
        }
      }
    }
    return _ret(byAll || byComp || byDim || any);
  };
})();


// ── Enricher universale card €/m2: per ogni card piastrella con link prodotto,
//    legge unit_price da /products/handle.js (dato LIVE Shopify) e mostra €/m2.
(function(){
  var cache = {};
  function money(c){ return (c/100).toFixed(2).replace('.', ',') + ' €'; }
  function urlOf(el){
    var card = el.closest('[data-product-url],[data-product-handle],.fx-product-card,.fx-product-standard-card,.ProductCard,.ProductItem,.grid__item,article,li');
    if (card){
      if (card.getAttribute && card.getAttribute('data-product-url')) return card.getAttribute('data-product-url').split('?')[0];
      if (card.getAttribute && card.getAttribute('data-product-handle')) return '/products/' + card.getAttribute('data-product-handle');
      var a = card.querySelector('a[href*="/products/"]'); if (a) return a.getAttribute('href').split('?')[0];
    }
    var aa = el.closest('a[href*="/products/"]'); if (aa) return aa.getAttribute('href').split('?')[0];
    return null;
  }
  function enrich(){
    document.querySelectorAll('.fx-price, .ProductCard__Price').forEach(function(el){
      if (el.getAttribute('data-khmq')) return;
      if (el.getAttribute('data-kh-server') === '1'){ el.setAttribute('data-khmq','1'); return; } // gia' corretto dal server -> niente fetch
      if ((el.textContent||'').toLowerCase().indexOf('mq') === -1) return; // solo card che mostrano /mq (piastrelle)
      var url = urlOf(el); if (!url) return;
      el.setAttribute('data-khmq','1');
      var fill = function(d){
        if (!d){ el.removeAttribute('data-khmq'); return; }
        el.setAttribute('data-price-cents', d.p);
        el.innerHTML = money(d.p) + '<span style="font-size:1em;color:inherit;">/</span><span style="font-size:0.9em;">mq</span>';
        /* KH-FEEDPRICE: aggiorna anche la scatola (piu economica = feed) se la card la mostra */
        if (d.box != null){
          var _c = el.closest('.fx-price-container, .fx-price-row, .fx-product-standard-card, .ProductCard, .ProductItem, article, li');
          var _bp = _c && _c.querySelector('.fx-box-price, .ProductCard__BoxPrice');
          if (_bp && /scatola/i.test(_bp.textContent||'')){
            _bp.innerHTML = money(d.box) + '/scatola <span class="fx-box-separator">&middot;</span> IVA incl.';
          }
        }
      };
      if (cache[url] !== undefined){ fill(cache[url]); return; }
      fetch(url.split('?')[0].replace(/\/+$/,'') + '.js').then(function(r){ return r.json(); }).then(function(p){
        /* KH-FEEDPRICE v3: variante col euro/mq PIU' BASSO (min unit_price), non piu' la scatola piu economica */
        var best = window.khMinMqFromVariants(p.variants);
        var d = best ? {p: best.unit_price, box: best.price} : null; cache[url]=d; fill(d);
      }).catch(function(){ el.removeAttribute('data-khmq'); });
    });
  }
  setInterval(enrich, 400);
})();
} // __KH_PREZZI_LOADED__


/* ===== KH FORMATO min €/mq (a partire da) — fix card ===== */
window.khFmtDisplayMq=function(variantId){
  try{ var vs=(window.productData&&window.productData.variants)||[]; var ref=null,i;
    for(i=0;i<vs.length;i++){ if(String(vs[i].id)===String(variantId)){ ref=vs[i]; break; } }
    if(!ref) return null;
    if(/batt/i.test(ref.option1||'')) return -1;               // battiscopa: no €/mq
    var o1=ref.option1||'', isR=/r11/i.test(ref.option3||''), mn=null, j;
    for(j=0;j<vs.length;j++){ var v=vs[j]; if(v.unit_price==null) continue;
      if((v.option1||'')!==o1) continue;                        // stesso formato+finitura
      if((/r11/i.test(v.option3||''))!==isR) continue;          // stesso stato R11
      if(mn==null||v.unit_price<mn) mn=v.unit_price; }
    return mn;
  }catch(e){ return null; }
};
window.khMQ=function(id,fb){ var m=window.khFmtDisplayMq?window.khFmtDisplayMq(id):null; if(m===-1) return null; if(m!=null) return m; return fb; };
/* ===== fine helper ===== */

